var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9815 18.5372V19.4446C16.9815 20.948 15.7627 22.1668 14.2593 22.1668C12.7558 22.1668 11.537 20.948 11.537 19.4446V18.5372M16.9815 18.5372H11.537M16.9815 18.5372H20.2395C20.5866 18.5372 20.761 18.5372 20.9016 18.4898C21.17 18.3992 21.3801 18.1884 21.4707 17.92C21.5183 17.7789 21.5183 17.6039 21.5183 17.2541C21.5183 17.101 21.5181 17.0244 21.5061 16.9515C21.4835 16.8135 21.43 16.6828 21.3484 16.5692C21.3054 16.5092 21.2506 16.4545 21.1427 16.3466L20.7892 15.9931C20.6752 15.8791 20.6111 15.7244 20.6111 15.5631V12.1853C20.6111 8.67731 17.7673 5.83349 14.2593 5.8335C10.7512 5.8335 7.90741 8.67732 7.90741 12.1853V15.5631C7.90741 15.7244 7.8432 15.879 7.72916 15.9931L7.37572 16.3465C7.26747 16.4548 7.21328 16.5092 7.17014 16.5693C7.08861 16.6828 7.03461 16.8135 7.01198 16.9515C7 17.0244 7 17.101 7 17.2541C7 17.6039 7 17.7788 7.0476 17.9199C7.13815 18.1884 7.34917 18.3992 7.61764 18.4898C7.75819 18.5372 7.93192 18.5372 8.27904 18.5372H11.537",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.c959b4a1a8319ec891109b9b47db9f46.svg";
export { ForwardRef as ReactComponent };